import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-scenes",
  "use": "icon-scenes-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-scenes\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M20.22,1.08l1.3,4.84L9.62,9h12v11a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V9H3L2.2,5.91a1,1,0,0,1,.72-1.23L19,.37A1,1,0,0,1,20.22,1.08Zm-.36,13.68h-15v4.51H19.86ZM9,10.85H4.81V13h3.4l-.06,0Zm10.9,0H16.31L15.49,13h4.37Zm-5.49,0H10.89L10.08,13h3.55l-.06,0Zm4.32-8.53L4.14,6.22l.59,2.24L19.31,4.64l-.62-2.32Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol